import React from 'react'

import {
  arrayOf,
  object,
  shape,
  string,
  bool,
} from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import HeroAuthor from './Components/HeroAuthor'
import Search from './Components/Search/Search'
import TrendingButtons from './Components/TrendingButtons'
import { HomeHeroSectionMock } from './HomeHeroSectionMock'
import { getImageType } from './Static/images'

function HomeHeroSection({
  images = EMPTY_OBJECT,
  searchPlaceholder = '',
  locale = 'en',
  trending = EMPTY_ARRAY,
  extractingCoreStyles = false,
  author = null,
}) {
  const desktopImage = images?.desktop
  const desktopSmallImage = images?.desktopSmall || images?.desktop
  const tabletImage = images?.tablet || images?.desktopSmall || images?.desktop
  const mobileImage = images?.mobile
  const heroTitle = i18n.t('hero.title', {
    ns: 'new-home',
    lng: locale,
  })
  const CreatedBy = i18n.t('hero.CreatedBy', {
    ns: 'new-home',
    lng: locale,
  })
  const heroAuthor = author?.name ? author : null
  const desktopIsDefault = desktopImage.includes('/assets/home/')
  const desktopSmallIsDefault = desktopSmallImage.includes('/assets/home/')
  const tabletIsDefault = tabletImage.includes('/assets/home/')
  const mobileIsDefault = mobileImage.includes('/assets/home/')
  const shouldShowAuthor =
    Boolean(author?.name) || desktopIsDefault || desktopSmallIsDefault || tabletIsDefault || mobileIsDefault
  const trendingButtons = extractingCoreStyles ? HomeHeroSectionMock : trending

  return (
    <div className="home-hero">
      {shouldShowAuthor && (
        <HeroAuthor createdByText={CreatedBy} author={heroAuthor} />
      )}
      <picture className="home-hero__background">
        {[
          { media: '(min-width: 1600px)', src: desktopImage },
          { media: '(min-width: 960px)', src: desktopSmallImage },
          { media: '(min-width: 640px)', src: tabletImage },
        ].map(({ media, src }) => (
          <source
            key={media}
            media={media}
            srcSet={src}
            type={getImageType(src)}
          />
        ))}
        <img
          alt="3D model marketplace background"
          className="home-hero__background-image"
          src={mobileImage}
          // eslint-disable-next-line react/no-unknown-property
          fetchpriority="high"
          loading="eager"
        />
      </picture>

      <div className="home-hero__content">
        <h1 className="home-hero__title">{heroTitle}</h1>

        <div className="home-hero__search">
          <Search placeholder={searchPlaceholder} locale={locale} />

          {locale === 'en' && trendingButtons.length > 0 && Array.isArray(trendingButtons) &&  (
            <div className="home-hero__trending-buttons-container">
              <TrendingButtons
                buttons={trendingButtons}
                buttonSize="small"
                customClass="home-hero__trending-button"
                trackingContext="home-hero"
                locale={locale}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

HomeHeroSection.propTypes = {
  images: object,
  searchPlaceholder: string,
  locale: string,
  author: shape({
    name: string,
    href: string,
    avatarUrl: string,
  }),
  trending: arrayOf(
    shape({
      label: string,
      href: string,
    })
  ),
  extractingCoreStyles: bool,
}

export default HomeHeroSection
